// src/text.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Text = React.forwardRef(
  ({ style, ...props }, forwardedRef) => /* @__PURE__ */ jsx(
    "p",
    {
      ...props,
      ref: forwardedRef,
      "data-id": "react-email-text",
      style: {
        fontSize: "14px",
        lineHeight: "24px",
        margin: "16px 0",
        ...style
      }
    }
  )
);
Text.displayName = "Text";
export {
  Text
};
